// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* stone-rebrand: overlay the Stone logo at the top of the error screen when the flag is on */\n.stone-rebrand-error[data-v-6e9cfcd3] {\n  position: relative;\n}\n.stone-rebrand-error__logo[data-v-6e9cfcd3] {\n  position: absolute;\n  top: 32px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  height: 32px;\n  width: auto;\n  z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
